import localStorage from 'localStorage'

export default function getCurrentUser () {

	return JSON.parse(localStorage.getItem('currentUser'))

}
